import React from 'react';
import { Link } from 'react-router-dom';
import { PlayCircle } from 'lucide-react';
import Button from '../common/Button';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';

const SimulatorTask = ({ taskDescription, targetPreset }) => {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100 rounded-xl p-8 my-10 flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-3">
          <span className="px-3 py-1 bg-[#0033A0] text-white text-xs font-bold uppercase tracking-wider rounded-full">Simulator Task</span>
        </div>
        <h3 className="text-xl font-bold text-[#1A1A2E] mb-2">Put it into Practice</h3>
        <div className="text-gray-700 leading-relaxed prose prose-sm max-w-none">
          <ReactMarkdown remarkPlugins={[remarkMath]} rehypePlugins={[rehypeKatex]}>
            {taskDescription}
          </ReactMarkdown>
        </div>
      </div>

      <Link to="/simulator">
        <Button size="lg" icon={PlayCircle} className="shadow-lg whitespace-nowrap">
          Launch Simulator
        </Button>
      </Link>
    </div>
  );
};

export default SimulatorTask;
